import { useEffect, useState } from 'react';
import API from '../../api';
import { useToast } from '../../context/ToastContext';
import { useConfirm } from '../../context/ConfirmContext';

export default function ManageUsers() {
  const [users, setUsers] = useState([]);
  const { addToast } = useToast();
  const confirm = useConfirm();
  const load = () => API.get('users/').then((r) => setUsers(r.data.results || r.data));
  useEffect(() => { load(); }, []);

  const handleDelete = async (id) => {
    if (await confirm('Supprimer cet utilisateur ?')) {
      await API.delete(`users/${id}/`);
      addToast('Utilisateur supprimé', 'info');
      load();
    }
  };

  return (
    <div>
      <div className="page-header">
        <h2><i className="bi bi-people" /> Gestion des utilisateurs</h2>
        <p>{users.length} utilisateur{users.length > 1 ? 's' : ''} enregistré{users.length > 1 ? 's' : ''}</p>
      </div>

      <div className="data-table-wrapper">
        <table className="data-table">
          <thead>
            <tr><th>Nom</th><th>Username</th><th>Email</th><th>Rôle</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr><td colSpan="5"><div className="empty-state"><i className="bi bi-people" /><p>Aucun utilisateur</p></div></td></tr>
            ) : users.map((u) => (
              <tr key={u.id}>
                <td>{u.first_name} {u.last_name}</td>
                <td>{u.username}</td>
                <td>{u.email}</td>
                <td><span className={`badge-role badge-${u.role}`}>{u.role}</span></td>
                <td>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(u.id)}><i className="bi bi-trash" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
